<template>
  <div class="column gap-2">
    <round-unit-dropdown
      :label="$t('labels.timeUnit')"
      :value="roundUnit"
      :is-custom="roundCustomized"
      :null-choosable="nullChoosable"
      :round-name="roundName"
      type="simple"
      @update:value="updateRoundUnit($event)"
      @update:is-custom="$emit('update:roundCustomized', $event)"
    />

    <div
      v-if="roundCustomized"
      class="round-duration-chooser__customoptions gap-2"
    >
      <input-number
        :value="roundLength"
        :min="1"
        step="any"
        class="round-duration-chooser__duration"
        @update:value="$emit('update:roundLength', $event)"
      />
      <round-unit-dropdown
        :value="roundUnit"
        :amount="roundLength"
        type="extended"
        @update:value="$emit('update:roundUnit', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import InputNumber from "@core/input/InputNumber.vue";
import RoundUnitDropdown from "./RoundUnitDropdown.vue";

import type { RoundUnit } from "./SimulationRoundItem";

const props = withDefaults(defineProps<{
  roundUnit?: RoundUnit;
  roundLength?: number;
  roundCustomized?: boolean;
  roundName?: string | null; // deprecated
  nullChoosable?: boolean;
}>(), {
  roundUnit: "round",
  roundLength: 1,
  roundCustomized: false,
  roundName: null, // deprecated
  nullChoosable: false
});

const emit = defineEmits<{
  (e: "update:roundUnit", value: RoundUnit | "custom" | null): void;
  (e: "update:roundLength", value: number): void;
  (e: "update:roundCustomized", value: boolean | null): void;
  (e: "update:roundName", value: string | null): void;
}>();


function updateRoundUnit(roundUnit: RoundUnit | "custom" | null) {
  if (roundUnit !== props.roundUnit) {
    emit("update:roundUnit", roundUnit);
    emit("update:roundName", null);
  }
}
</script>
